import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from 'redux/store';
import { ROUTE } from 'util/constants';

interface ConditionalRedirection {
  condition: boolean;
  route: string;
}
interface Props {
  requiresAuth?: boolean;
  redirectToClosed?: boolean;
  conditionalRedirection?: ConditionalRedirection;
  [x: string]: any;
}

export const ProtectedRoute: FC<Props> = ({
  requiresAuth = true,
  redirectToClosed,
  conditionalRedirection,
  ...rest
}) => {
  const userData = useSelector((state: RootState) => state.user.data);

  if (redirectToClosed) {
    return <Redirect to={ROUTE.CLOSED}></Redirect>;
  }

  if (conditionalRedirection && conditionalRedirection?.condition) {
    return <Redirect to={conditionalRedirection!.route}></Redirect>;
  }

  if (requiresAuth && !userData) {
    return <Redirect to={ROUTE.HOME}></Redirect>;
  }

  return <Route {...rest}>{rest.children}</Route>;
};
